<template>
  <div class="wrapper">
     <iframe class="iframeBox" :src="url" frameborder="0"></iframe>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      url: '',
    }
  },
  methods: {
    
  },
  created() {
  },
  mounted() {
    this.url= decodeURIComponent(this.$route.query.url)
    document.title = decodeURIComponent(this.$route.query.title)
    let option = {
      title: "有米@" + this.userInfo.name + "的店铺",
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl,
    };
    this.weChatShare(option);
  },
}
</script>

<style scoped lang='less'>
.wrapper{
  width: 100%;
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}
.iframeBox{
  width: 100%;
  min-height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/index/iframe.vue